import { useRef, useState } from 'react'
import { ReactComponent as EditIcon } from "assets/images/icons/edit.svg"
import { ButtonLoader } from 'components/__new/common/form';
import EditAllowanceForm from './EditAllowanceForm';
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import PaygroupsListTable from '../PaygroupsListTable';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { assignAllowancePayGroups, getAllowancePayGroups, unassignAllowancePayGroups } from 'store/entities/payroll/payrollSetup/action';

const ViewAllowanceDetails = () => {
    const location = useLocation()
    const submitRef = useRef(null)
    const {useSelector, history, dispatch } = usePayrollEssentials();

    const {selectedAllowance: data, editAllowanceLoading: editLoading, allowancePayGroupsLoading, allowancePayGroupsData, assignAllowanceGroupsLoading, unassignAllowanceGroupsLoading} = useSelector(state => state.entities.payrollSetup)
    const [current, setCurrent] = useState(0);
    const [selected, setSelected] = useState([]);
    const selectedAllowance = location?.state?.payload;
    const [isViewing, setIsViewing] = useState(true);
    const id = selectedAllowance?.id || data?.id;

    const items = [
        {title: "Allowance Details", Component: (
            <div className="w-full"><EditAllowanceForm data={selectedAllowance} submitRef={submitRef} isViewing={isViewing} /> </div> )},
        {title: "Allowance Pay Group(s) List", Component: (
            <div className="w-full">
                <PaygroupsListTable
                    title={selectedAllowance?.name}
                    isViewing={isViewing}
                    selected={selected}
                    setSelected={setSelected}
                    setCurrent={setCurrent}
                    payGroupsData={allowancePayGroupsData}
                    payGroupsLoading={allowancePayGroupsLoading}
                    onMount={(params) => dispatch(getAllowancePayGroups({id, ...params}))}
                    updateLoading={assignAllowanceGroupsLoading || unassignAllowanceGroupsLoading}
                    assignPayGroupFn={() => dispatch(assignAllowancePayGroups({
                        allowance_and_bonus_id: id,
                        pay_group_ids: selected
                    }))}
                    unassignPayGroupFn={(payload) =>
                        dispatch(unassignAllowancePayGroups({
                        allowance_and_bonus_id: id,
                        pay_group_ids: payload
                    }))}
                />
            </div>
        )}
    ]

    useEffect(() => {
        if(!selectedAllowance?.name?.length && !data?.name?.length) {
            history.push('/payroll-configuration/allowances')
        }
    // eslint-disable-next-line
    }, [])


    return (
    <div className="w-full">
        <div className="flex-btw items-center flex-wrap lg:flex-nowrap pb-3 lg:pb-0">
            <div className="w-full lg:w-2/4 mb-5 lg:mb-0">
                <p className="mb-0 font-medium prl-bold">{isViewing ? "View" : "Edit"} "{selectedAllowance?.name}" Allowance</p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center lg:justify-end">
                <ButtonLoader loading={editLoading}
                    className="btn btn-md btn-ep-primary mr-4 lg:mr-6"
                    onClick={() => isViewing ? setIsViewing(!isViewing) : submitRef?.current?.click()}>
                    {isViewing ? <span className='flex items-center pr-3'>
                        <EditIcon className='mr-3' /> Edit
                    </span> : editLoading ? "Submitting..." : "Update Details"}
                </ButtonLoader>
                <button disabled={editLoading} onClick={() => history.push("/payroll-configuration/allowances")} className="btn btn-md btn-transparent-primary">
                    Cancel
                </button>
            </div>
        </div>
        <div className="bg-white p-5 pb-14 mt-7 lg:mt-10 rounded-md">
                <div className='w-full pt-4'>
                    <div className="w-full flex border-b pb-2">
                    {items.map(({title}, idx) => {
                    const isActive = current === idx
                    return <div onClick={() => setCurrent(idx)} key={idx} className={`mr-6 text-sm cursor-pointer ${isActive ? 'relative text-ep-primary-600 font-medium' : 'text-[#7a8096]'}`}>
                            <p className="mb-0">{title}</p>
                            {isActive && <div style={{height: '2px', bottom: '-8px'}} className='absolute w-full left-0 bg-ep-primary-600' />}
                    </div>
                    })}
                    </div>
                </div>
                <div className={`mt-5 w-full ${current === 1 ? "w-full" : "lg:w-3/5"}`}>{items[current].Component}</div>
        </div>
    </div>
    )
}

export default ViewAllowanceDetails